import type { IClient, TemplateViewParams } from "@/models/clients";
import type { FileBase, IPaginatedResponse } from "@/models/common";
import type {
  ContractTemplateField,
  ContractTemplateRecipientRole,
} from "@/models/options";
import type { IUser } from "@/models/users";

export type ContractType =
  | "equipment_rental"
  | "equipment_share"
  | "erc_csa_flat"
  | "erc_full"
  | "sale_of_future_receipts"
  | "marketplace";

export enum ContractStatus {
  draft = 1,
  published = 2,
}

export interface ContractTemplate {
  id: string;
  name: string;
  type: ContractType;
  template_id: string;
  client: IClient | null;
}

export interface ContractBuilderState {
  placeholders: ContractTemplate[];
  gettingPlaceholders: boolean;
  gettingTemplates: boolean;
  templates: IPaginatedResponse<ContractTemplateV2>;
  activeTemplate: ContractTemplateV2 | null;
}

export interface ContractTemplateV2 {
  id: string | number;
  color: string | null;
  created_at: string;
  description: string;
  is_lendflow_template: boolean;
  name: string;
  status: number;
  updated_at: string;
  client?: IClient | null;
  content?: ContractTemplateContent;
  created_by?: IUser;
  document?: FileBase;
}

export interface GetContractTemplateParams {
  include_content: boolean;
}

export interface ContractTemplateContent {
  version: string;
  recipients: ContractRecipient[];
  description?: string;
}

export interface ContractRecipient {
  role: ContractTemplateRecipientRole;
  fields: ContractField[];
  id: string;
}

export interface ContractField {
  id: string;
  tabLabel: string;
  pageNumber: number;
  xPosition: number;
  yPosition: number;
  required: boolean;
  context?: ContractCustomAttributeContext;
}

export interface ContractCustomAttributeContext {
  type: "custom_attribute" | "offer_detail";
  value: {
    id?: string;
    mode?: "offer" | "closing";
    name?: string;
    offer_template_id?: string;
  };
}

export interface ContractFieldWithName extends ContractField {
  name?: string;
  role: RoleWithID;
}

export interface RoleAndFieldsDetails {
  role: ContractTemplateRecipientRole;
  id: string;
  fields: ContractFieldWithName[];
}

export interface ContractBuilderViewParams extends TemplateViewParams {
  status?: number;
  clients?: string[];
}

export interface RoleWithID {
  id: string;
  role: ContractTemplateRecipientRole;
}

export interface ContractTemplateFieldCategory {
  category: string;
  fields: ContractTemplateField[];
}
